package gr.tech.pdfgenerator.infrastructure.calculations

fun Double.toPercentage(): String {
    return "${this.times(100)}%"
}